/**
 * stripeOnboardingHelper.js
 *
 * Shared utilities for handling Stripe onboarding flows across
 * different contexts (gift claiming, pool acceptance, etc.)
 */

/**
 * Handle Stripe onboarding redirect after signup
 * Stores context in sessionStorage and redirects to Stripe
 *
 * @param {Object} signupResult - Result from signup API call
 * @param {string} context - Context type: 'pool_acceptance' or 'gift_claim'
 * @param {Object} contextData - Additional data to store (e.g., token, claimToken, etc.)
 * @returns {boolean} - True if redirect happened, false otherwise
 */
export function handleStripeOnboardingRedirect(signupResult, context, contextData = {}) {
  if (signupResult?.stripe_onboarding_required && signupResult?.stripe_onboarding_url) {
    // Store context for return flow
    sessionStorage.setItem('stripe_onboarding_context', context);
    sessionStorage.setItem('stripe_onboarding_data', JSON.stringify(contextData));

    // Redirect to Stripe onboarding
    window.location.href = signupResult.stripe_onboarding_url;
    return true;
  }
  return false;
}

/**
 * Get stored onboarding context after returning from Stripe
 *
 * @returns {Object|null} - { context, data } or null if no context stored
 */
export function getStripeOnboardingContext() {
  const context = sessionStorage.getItem('stripe_onboarding_context');
  const dataStr = sessionStorage.getItem('stripe_onboarding_data');

  if (!context) return null;

  return {
    context,
    data: dataStr ? JSON.parse(dataStr) : {},
  };
}

/**
 * Clear stored onboarding context
 */
export function clearStripeOnboardingContext() {
  sessionStorage.removeItem('stripe_onboarding_context');
  sessionStorage.removeItem('stripe_onboarding_data');
}
